import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { fetchAllProducts, type Product } from '../data/productService';

interface ProductContextValue {
  products: Product[];
  loading: boolean;
  error: string | null;
}

const ProductContext = createContext<ProductContextValue>({
  products: [],
  loading: true,
  error: null,
});

export function ProductProvider({ children }: { children: ReactNode }) {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetchAllProducts()
      .then(data => {
        if (!cancelled) {
          setProducts(data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load products');
          setLoading(false);
        }
      });

    return () => { cancelled = true; };
  }, []);

  return (
    <ProductContext.Provider value={{ products, loading, error }}>
      {children}
    </ProductContext.Provider>
  );
}

export function useProducts(): ProductContextValue {
  return useContext(ProductContext);
}
